export default "__VITE_ASSET__67b4085f__"